export enum NewsContentType {
    /**
     * html
     */
    HTML = 1,

    /**
     * 链接
     */
    LINK = 2
}

export interface News {
    id?: string;

    // 资讯标题
    title?: string

    // 标签
    tagName?:string

    contentType?: NewsContentType

    link?: string

    // 发布时间
    publicationTime?: number
}

export interface NewsDetail extends News {
    content?: string
}